import React from "react";
import { Link } from "react-router-dom";
import { services } from "../data/services";

const ServiceOne = () => {
  return (
    <div className="service-area-1 space overflow-hidden">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7">
            <div className="title-area text-center">
              <span className="sub-title">
                <img src="assets/img/icon/title_left.svg" alt="shape" />
                Our services
              </span>
              <h2 className="sec-title style2">
                Empowering Business The Excellence
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row gx-30 gy-30 justify-content-center">
          {services.map((service) => (
            <div className="col-md-6" key={service.id}>
              <div className="service-card">
                <div className="service-card_img">
                  <img src={service.image} alt={service.title} />
                </div>
                <div className="service-card_content">
                  <h4 className="service-card_title">
                    <Link to={`/service-details/${service.id}`}>{service.title}</Link>
                  </h4>
                  <p className="service-card_text">{service.description}</p>
                  <Link to={`/service-details/${service.id}`} className="link-btn">
                    Read More <i className="fas fa-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceOne;